import React from 'react';

import { DEFAULT_AVATAR } from 'src/assets';
import { BaseLayout } from 'src/components/common';
import { useGlobalState } from 'src/hooks/shared';
import { useCurrentUser, useUserAvatar } from 'src/hooks/user';

import { LayoutHeader, LayoutLeftMenu } from './components';

export const EmployerManagerLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { leftMenuDrawerState } = useGlobalState();

  const { user, userFullName } = useCurrentUser();
  const { userAvatar } = useUserAvatar(user?.id);

  return (
    <BaseLayout
      header={<LayoutHeader />}
      leftMenu={<LayoutLeftMenu />}
      currentUserFullName={userFullName}
      currentUserAvatarUrl={userAvatar?.downloadUrl}
      defaultLogoUrl={DEFAULT_AVATAR}
      content={children}
      leftMenuDrawerState={leftMenuDrawerState}
    />
  );
};
